import {Injectable} from '@angular/core';
import {ModelProvider} from "../../framework/providers/modelProvider/ModelProvider";
import {BusinessService} from "./BusinessService";
import {Business} from "../../framework/model/core/business/business";

import {AppUser} from "../../framework/model/core/appuser/appuser";
import {OrderService} from "./OrderService";
import {ResObject} from "../../app/global-module/global-module.module";
import {TranslateService} from "@ngx-translate/core";
import {ModelToolsProvider} from "../../framework/providers/model-tools/model-tools";
import {Events} from "../../framework/providers/events";

declare var FirebaseConfig;

@Injectable()
export class PushService {

    private business: Business;
    private appuser: AppUser;

    private pushId = '';

    // private push: Push;
    constructor(private modelProvider: ModelProvider, public businessService: BusinessService, public modelTools: ModelToolsProvider,
                public events: Events, public orderService: OrderService, public translate: TranslateService) {
    }

    ngOnInit() {
    }

    start() {
        //console.log"PUSH SERVICE START!");
        //
        // if (!firebase.apps.length) {
        //     firebase.initializeApp(FirebaseConfig);
        // } else {
        //     firebase.app(); // if already initialized, use that one
        // }

        this.setPushId();

        this.events.subscribe('businessSets', (params) => {
            this.business = this.businessService.getBusiness();
        });

        this.events.subscribe('appuserChanged', (params) => {
            this.appuser = this.orderService.getAppUser();
            this.checkPushId();
        })
    }

    setPushId() {
        // this.pushId = this.business.data.prefix + '_pushId' + Math.floor(Math.random() * Math.floor(1000000000000000));

        // this.push.hasPermission()
        //     .then((res: any) => {
        //         //console.log'push res', res)
        //         if (res.isEnabled) {
        //             //console.log'We have permission to send push notifications');
        //         } else {
        //             //console.log'We do not have permission to send push notifications');
        //         }
        //
        //     });

        // this.getExistChannels();

        this.addPushId();
    }

    addPushId() {
        //console.log'isPushNotificationsAvailable')
        // //console.logCapacitor.isPluginAvailable('PushNotifications'))
        // if (!isPushNotificationsAvailable) {
        //     return
        // }

        // const config = {
        //     apiKey: 'AIzaSyBVGnHLxajkN1WKPyNVpnSJtzBV-h2cvUo',
        //     // authDomain: '<your-project-authdomain>',
        //     // databaseURL: '<your-database-URL>',
        //     projectId: 'oneflow-296716',
        //     // storageBucket: '<your-storage-bucket>',
        //     // messagingSenderId: '<your-messaging-sender-id>'
        // };
        // AngularFireModule.initializeApp(Context)

        // PushNotifications.requestPermission().then(result => {
        //     //console.log'pushresult', result)
        //     if (result.granted) {
        //         // Register with Apple / Google to receive push via APNS/FCM
        //         PushNotifications.register();
        //     } else {
        //         // Show some error
        //     }
        // });
        //
        // PushNotifications.addListener(
        //     'registration',
        //     (token: PushNotificationToken) => {
        //         //console.log"token tokentokentokentokentokentokentokentokentokentokentokentokentokentokentoken token");
        //         //console.logtoken);
        //         this.pushId = token.value;
        //         // alert('Push registration success, token: ' + token.value);
        //     },
        // );
        //
        // PushNotifications.addListener('registrationError', (error: any) => {
        //     // alert('Error on registration: ' + JSON.stringify(error));
        // });
        //
        // PushNotifications.addListener(
        //     'pushNotificationReceived',
        //     (notification: PushNotification) => {
        //         let data = notification;
        //         let buttons = [
        //             {
        //                 side: 'end',
        //                 // icon: 'star',
        //                 text: 'show',
        //                 handler: () => {
        //                     this.modelTools.goTo(data['data']['page'] + '/' + data['data']['modelId'])
        //                     // //console.log'Favorite clicked');
        //                 }
        //             }
        //         ];
        //         //console.logdata);
        //         this.modelProvider.presentToast(data['body'], true, 'dark', buttons, true, data['title']);
        //         // alert('Push received: ' + JSON.stringify(notification));
        //     }
        // );
        //
        // PushNotifications.addListener(
        //     'pushNotificationActionPerformed',
        //     (notification: PushNotificationActionPerformed) => {
        //         // alert('Push action performed: ' + JSON.stringify(notification));
        //     },
        // );

        // this.push.createChannel({
        //      id: this.pushId,
        //      description: this.pushId,
        //      // The importance property goes from 1 = Lowest, 2 = Low, 3 = Normal, 4 = High and 5 = Highest.
        //      importance: 3
        //  }).then(() => //console.log'Channel created'));

        // let me = this;
        //
        // const options: PushOptions = {
        //     android: {},
        //     ios: {
        //         alert: 'true',
        //         badge: true,
        //         sound: 'false'
        //     },
        //     windows: {},
        //     browser: {
        //         pushServiceURL: 'shaps.co.il'
        //     }
        // }
        //
        // const pushObject: PushObject = this.push.init(options);
        //
        // pushObject.on('registration').subscribe((data: any) => {
        //     //console.log'Push Reg: ', data);
        //     me.pushId = data['registrationId'];
        // });
        //
        // pushObject.on('notification').subscribe((data: any) => {
        //     //console.log'Push Received: ', data);
        //     me.modelProvider.presentToast(data.message)
        //
        //     //console.log'push publish', 'push_' + data['additionalData']['type'])
        //     me.events.publish('push_' + data['additionalData']['type'], data['additionalData'])
        //     // alert('New Notification' + data.message);
        // });
        //
        // pushObject.on('error').subscribe(error => {
        //     //console.log"ERROR is: " + error);
        // })
    }

    checkPushId() {
        if (!this.appuser)
            return

        //console.log"### PUSH ID", this.pushId);
        //console.log"### PUSH ID", this.appuser.data.pushId);
        //console.log"### PUSH ID", this.appuser.data.id);
        if (this.pushId && this.appuser.data.pushId != this.pushId) {
            this.appuser.data.pushId = this.pushId;
            this.modelProvider.update(this.appuser, {'pref': this.appuser.data.prefix}).then((res: ResObject) => {
                //console.log'update is done push!!!!!! ######')
            });
        }
    }

    getExistChannels() {
        // let id =
        // //console.log"getExistChannels !!!!!!!!!!!!!!")
        // this.push.listChannels().then((channels) => //console.log'List of channels', channels))
    }

    getPushId() {
        return this.pushId;
    }


}









